import { t } from "@lingui/macro";
import {
  type ExpenseForNavigationQuery,
  useExpenseForNavigationQuery,
} from "@src/__generated__/graphql";
import { useNavigationPages } from "@src/components/widgets/AppSubNav/hooks";
import type { NavigationHook } from "@src/components/widgets/AppSubNav/hooks/types";

export function useExpenseNavigation(
  expenseId?: string,
): NavigationHook<ExpenseForNavigationQuery["expense"]> {
  const { data, loading } = useExpenseForNavigationQuery({
    fetchPolicy: "cache-first",
    variables: {
      id: expenseId ?? "",
    },
    skip: !expenseId,
  });

  const expenseTitle = data?.expense.is_draft
    ? `${t`Draft`} #${data.expense.id}`
    : data?.expense.expense_no
      ? `${t`Edit expense`} #${data.expense.expense_no}`
      : t`Edit expense`;

  const { activePage, activeSubpage, allPages, visiblePages } =
    useNavigationPages([
      {
        title: () => t`Expenses`,
        href: {
          pathname: "/expenses",
        },
        subPages: [
          {
            title: () => expenseTitle,
            href: {
              pathname: "/expenses/edit",
              query: { id: expenseId },
            },
          },
          {
            title: () => t`New expense`,
            href: {
              pathname: "/expenses/create",
            },
          },
        ],
      },
    ]);

  return {
    activePage,
    activeSubpage,
    allPages,
    visiblePages,
    data: data?.expense,
    isLoading: loading,
  };
}
